import type { ApolloError } from '@apollo/client';
import { parseNetworkErrorDetails } from '@shared/utils/parseNetworkErrorDetails';

export type CreateEventErrorType = 'clientBlock' | 'serverError' | 'rateLimit';

export const classifyCreateEventError = (error: ApolloError): CreateEventErrorType => {
  // Rate limit — check first, keep existing behavior
  if (error.graphQLErrors[0]?.extensions?.props.statusCode === 429) {
    return 'rateLimit';
  }

  const { statusCode, isTimeout, isHtmlResponse } = parseNetworkErrorDetails(error);
  const message = error.message?.toLowerCase() ?? '';

  // Client-side block: fetch failures, network errors, offline
  const isFetchFailure = message.includes('failed to fetch') || message.includes('networkerror') || message.includes('network request failed') || message.includes('load failed');

  const isNetworkLevelError = error.networkError && !statusCode && !isTimeout && !isHtmlResponse;

  if (isFetchFailure || isNetworkLevelError) {
    return 'clientBlock';
  }

  // Everything else: 5xx, timeout, HTML response, unknown → server error
  // Default to serverError to avoid blaming the user
  return 'serverError';
};
